// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "all-251118-1/static/css/" + chunkId + "." + "1962ecbc" + ".chunk.css";
};